var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer--mentions-and-language wrapper",
    attrs: {
      "id": "modal-call"
    }
  }, [_c('Mentions', {
    attrs: {
      "is-scramble-link": _vm.isScrambleLink
    }
  }), _vm._v(" "), _c('Language')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };